import styled from "styled-components";
import { Pagination } from "../../../../components/Pagination";
import { Search } from "../../../../hooks/useBlogs";
import { Post } from "../Post";

interface paramsProps {
  results?: any[];
  submit(search: Search|null, page: number): void;
  pagination?: {
			page: number,
			pageSize: number,
			pageCount: number,
			total: number
  }|null;
}

type pageBtn = {
  page: number,
  selected: boolean
}

export function Results({ results, submit, pagination = null }: paramsProps) {
  if(!results) results = [];
  if(!pagination) pagination = {page: 0, pageCount: 0, pageSize: 10, total: 0};
  
  function iteratePages() {
    let pages: pageBtn[] = [];
    if(!pagination?.pageCount) return pages;

    const initialCount = pagination?.pageCount?  pagination?.pageCount : 0
    for (let i = 1; i <= initialCount; i++) {
      pages.push({
        page: i,
        selected: pagination?.page === i
      })
    }

    return pages;
  }
  
  async function onSubmit(page: number, e: any) {
    e?.preventDefault();
    
    await submit(null, page);
  }

  
  
  return (
    <Content>
      <Title title={"Blog"} />
      {results.length > 0 ? (
        <PostsList>
          {results.map((post, index) => <Post key={index} post={post} />)}
        </PostsList>
      ) : (
        <NoResults>
          Resultados não encontrados
        </NoResults>
      )}
      <Pagination
        max-width={'500px'}
        left={'53%'}
        transform={'translate(-50%, 40%)'}
        pages={iteratePages()}
        onSubmit={onSubmit}
      />
    </Content>
  );
}

const Content = styled.div`
  width: calc(74% - 12px);
  padding: 32px 0 0 32px;
  position: relative;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: calc(60% - 12px);
    padding: 32px 0 32px;
    margin-bottom: 32px;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    width: 100%;
    padding-top: 14px;
    margin-bottom: 32px;
  }
`;

const Title = styled.span`
  display: inline-block;
  color: ${({ theme }) => theme.colors.blue.dark };
  text-transform: uppercase;
  font-size: 17px;
  margin-bottom: 16px;
  position: absolute;
  top: 0;
  left: 32px;
  transform: translateY(-50%);
  background-color: #fff;
  padding: 0 16px;
`;

const PostsList = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 56px;
  list-style-type: none;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const NoResults = styled.span`
  display: block;
  text-align: center;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.gray.darker };
`;
